<script>
///Ultima alteração: 27/07/2020
///Alterado por: Allinne

	import { Router, Link, link, Route }   from "svelte-routing";

	export let subitems = [];
	
	export let classeli   = "";
	export let classe   = "";
	export let href     = "javascript:void(0);";
	export let icon     = "";
	export let target   = "";
	export let separator = false;

	export let title     = "";

	console.log(title, separator);
	
	function toggleMenu(){
		jQuery('.navbar-toggler').click();
	}
	
	function forceReload() {
		window.setTimeout(()=>window.history.go(0), 50);
	}
</script>
{#if subitems != null && subitems.length > 0}
	<li class="item dropdown {classeli}">
		<a class="dropdown-toggle" {href} title="{title}" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{@html title} <span class="ml-5 icon">{@html icon}</span>
		</a>
		<div class="dropdown-menu" aria-labelledby="navbarDropdown">
			{#each subitems as submenu}
				{#if submenu.separator }
					<div class="separator"></div>
				{:else if submenu.useLink == false}
					<a class="dropdown-item d-none d-lg-block {submenu.classe=''}" href="{submenu.href}" target="{submenu.target}" title="{submenu.title='Ir para ' + submenu.title}" on:click={() => { if(submenu.forceReload){forceReload();}}}>
						{submenu.title}
					</a>
					<a class="dropdown-item d-block d-lg-none {submenu.classe=''}" href="{submenu.href}" target="{submenu.target}" title="{submenu.title='Ir para ' + submenu.title}" data-target=".navbar-collapse" data-toggle="collapse">
						{submenu.title}
					</a>
				{:else}
					<a class="dropdown-item d-none d-lg-block {submenu.classe=''}" href="{submenu.href}" target="{submenu.target}" use:link replace title="{submenu.title='Ir para ' + submenu.title}" on:click={() => { if(submenu.forceReload){forceReload();}}}>
						{submenu.title}
					</a>
					<a class="dropdown-item d-block d-lg-none {submenu.classe=''}" href="{submenu.href}" target="{submenu.target}" use:link replace title="{submenu.title='Ir para ' + submenu.title}" data-target=".navbar-collapse" data-toggle="collapse">
						{submenu.title}
					</a>
				{/if}
			{/each}
		</div>
	</li>
{:else}
	<li class="item {classeli}">
		<a class="d-none d-lg-block {classe}" {href} {target} title="Ir para {title}">
			<span class="icon">
				{@html icon}
			</span> 
			{@html title} 
		</a>
		<a class="d-block d-lg-none {classe}" {href} {target} title="Ir para {title}" on:click={toggleMenu}>
			<span class="icon">
				{@html icon}
			</span> 
			{@html title}
		</a>
	</li>
{/if}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.item 
	a 
		display: flex
		align-items: center
		&:hover
			text-decoration: none
		.icon
			padding-right: 5px

// Desktop
+media-breakpoint-up(lg)
	.item
		&.dropdown
			.dropdown-menu 
				padding: 15px
				margin-top: 1em
				margin-left: -4em
				&:before
					content: ""
					top: -8px
					left: 4em
					position: absolute
					border-left: 8px solid transparent
					border-right: 8px solid transparent
					border-top: 8px solid #ccc
					transform: rotate(179deg)
				.dropdown-item
					margin: 5px 0
					padding: 5px
			.dropdown-toggle
				&[aria-expanded="true"]
					color: #ccc
				&::after
					display: none

// Mobile
+media-breakpoint-down(md)
	.item
		width: 100%
		a
			padding: 10px 0
		.btn
			width: 100%
			text-align: center
		.dropdown-menu
			border: 0		
			margin-top: -10px
			.dropdown-item 					
				margin-left: 25px
				padding: 5px

</style>